import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';
import { api } from '../api/client';
import { ROLE_LABELS } from '@aisolution/shared';

export function Layout({ children }: { children: ReactNode }) {
  const { user, setUser } = useAuth();

  async function logout() {
    await api.logout().catch(() => {});
    setUser(null);
  }

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          <div className="logo">3D</div>
          <div className="name">The AI Solution<small>3DTSI Estimating</small></div>
        </div>
        <nav className="nav">
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/new">New Bid</NavLink>
          <div className="phase-tag">Pipeline</div>
          <NavLink to="/upload">Document Upload</NavLink>
          <NavLink to="/analysis">Document Analysis</NavLink>
          <NavLink to="/systems">System Selection</NavLink>
          <NavLink to="/count">Count Sheet</NavLink>
          <NavLink to="/bom">BOM Builder</NavLink>
          <NavLink to="/pricing">Pricing</NavLink>
          <NavLink to="/estimate">Estimate</NavLink>
          <NavLink to="/proposals">Proposals</NavLink>
          {user?.role === 'admin' && (<><div className="phase-tag">Admin</div><NavLink to="/admin">Admin Settings</NavLink></>)}
        </nav>
      </aside>
      <div className="main">
        <header className="topbar">
          <div className="muted" style={{ fontSize: 13 }}>Low-Voltage Division 27/28 · AI reads, humans count</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span className="who">{user?.name} · {user ? ROLE_LABELS[user.role] : ''}</span>
            <button className="btn btn-ghost" onClick={logout}>Sign out</button>
          </div>
        </header>
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
